import React from 'react'
import { Container, Grid, Image, Card, Icon, Message, Button } from 'semantic-ui-react'
import NumberCard from './../../../drive/NumberCard'
import shieldIcon from './../../../../images/grafix-icon/icon-shield-user.svg'
import createAccount from "./../../../../images/grafix-banner/gfx-account.svg";
import './../styles.css'
import { dispatch } from '@rematch/core';
import InviteUserModal from './../drive/Modal/InviteUserModal'
import CreateNewWorkspaceModal from '../drive/Modal/CreateNewWorkspaceModal';
import { toastr } from 'react-redux-toastr';
import EllipsisTooltip from '../../../common/EllipsisTooltip';
import UserCache from "../../../../helpers/cache/userCache";
import { format } from "date-fns";
import Labels from '../../../common/Labels'
import InfoCard from './../../../drive/InfoCard';
import CommonTable from '../../../drive/Table/TableLayoutWoFilter'
import WorkspaceTableHeaders from './WorkspaceTableHeaders.json';
import TableHeaders from "./TableHeaders.json"
import AccountSelectionModal from '../../../layout/Modal/AccountSelectionModal';
import LoadingComponent from '../../../common/LoadingComponent';

let server_url = process.env.REACT_APP_SERVER_URL;

if (!server_url || server_url === "") {
    server_url = `${window.location.protocol}//${window.location.hostname}`;
    if (window.location.port !== "") {
        server_url = `${server_url}:${window.location.port}`;
    }
}

class MainPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inviteUserModalFlag: false,
            createNewWorkspaceModalFlag: false,
            type: "",
            data: null,
            plans: null,
            _sort: "name",
            _limit: 10,
            tableHeader: WorkspaceTableHeaders,
            disHeaders: TableHeaders,
            open: false,
            loading: false,
        };

        this.handleDropDownItem = this.handleDropDownItem.bind(this);

        this.gotoInviteUser = this.gotoInviteUser.bind(this);
        this.goToSubscription = this.goToSubscription.bind(this);
        // this.takeTour = this.takeTour.bind(this);
        this.openCreateNewWorkspaceModal = this.openCreateNewWorkspaceModal.bind(this)
        this.handleReactivateAccount = this.handleReactivateAccount.bind(this)
    }

    setInviteUserModal = (open) => {
        this.setState({ inviteUserModalFlag: open })
    }

    gotoInviteUser = (e) => {
        this.setInviteUserModal(true)
    }

    async componentDidMount() {

        const requestUrl = `${server_url}/plans`;
        fetch(requestUrl)
            .then(response => response.json())
            .then(plans => this.setState({ plans }));

            this.onQueryChange()



    }


    componentWillMount() {
        if (this.props && this.props.organizationList) {
            this.disableTableActions();
        }
        dispatch.account.getAllAccounts(this.props.user._id);
        const userCacheObject = new UserCache(this.props.userCache);
        const accountUserData = userCacheObject.getAccountUsers(this.props.selectedAccount._id);
        this.setState({
            accountUserData: accountUserData,
        })

    }

    componentWillReceiveProps = async (nextProps) => {
        if (nextProps && nextProps.organizationList) {
            this.setState({ loading: true });
            await this.disableTableActions();
            this.setState({ loading:false });
        }

    }

    disableTableActions = async () => {

        if (await this.props.organizationList && await this.props.organizationList.data) {
            for (let i = 0; i < this.props.organizationList.data.length; i++) {
                let o = this.props.organizationList.data[i]
                // Disabled Button If user not to Rename access
                if (o.active) {
                    o.isRenameAccess = false
                    o.isDeleteAccess = false
                    o.isViewAccess = false
                } else {    
                    o.isRenameAccess = true
                    o.isDeleteAccess = true
                    o.isViewAccess = true
                }
                if(o.role !== "workspaceOwner") {
                    o.isActiveDisabled = true
                    o.isRenameAccess = true
                    o.isDeleteAccess = true
                }
                // Current its disabled so add condition for anable or disable these access
                o.isExportAccess = true;
                o.isMigrateAccess = true;
                o.isArchiveAccess = true;
            }
        }
    }


    onQueryChange = (query) => {
        if (query) {
            this.setState({ query: query })
            dispatch.app.setTableFilterQuery(query)
        }
        setTimeout(() => {
            let payload = this.state.query;
            dispatch.account.getAcountUserWorkspaces(payload)
        }, 100);
    };


    addColumn = (newColumns) => {
        if (newColumns) {
            this.setState({ tableHeader: newColumns, disHeaders: newColumns })
        }
    };


    handleDropDownItem = (event, type, data, clickedCount) => {
        let isAccountDeactivated = false
        let isWorkSpaceActive = false
        let account = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id.toString() === this.props.selectedAccount._id.toString() })[0];
        let orgList = this.props.organizationList.data.filter((orgId) => {return orgId.id.toString() === data.id.toString()})[0]
        if (account.role === "customerAdmin" && !account.isActive) {
            isAccountDeactivated = true;
        }
         
        
        
        if(!orgList.active) {
            isWorkSpaceActive = true
        }


        if (type.text === "View" && !type.isComponent) {
            if (!isAccountDeactivated){
                this.redirectToWorkspace(data);
            }
        }

        if (type.text === "Rename") {
            if (!isAccountDeactivated && !isWorkSpaceActive && data.role === "workspaceOwner") {
                this.openCreateNewWorkspaceModal(true, "edit", data)
            }
        }

        if (type.text === "Delete") {
            if (!isAccountDeactivated && data.role === "workspaceOwner") {
                this.deleteWorkspace(data)
            }
        }
    }
    handleTableComponent = (event, item, data) => {
        if(item.name==="checkbox" && data.active === true) {
            this.markDefault(event, item, data._id);
        }
        if(item.name==="checkbox2") {
            this.markActive(event, item, data._id)
        }
        if(item.name==="checkbox3") {
            this.markActive(event, item, data._id)
        }
    }

    markDefault(e, data, organizationId) {
        let payload = {
            organizationId: organizationId,
            default: data.checked,
            accountId: this.props.match.params.accountId
        }
        dispatch.organizationUnit.setDefaultWorkspace(payload);
    }

    markActive(e, data, organizationId) {
        let payload = {
            organizationId: organizationId,
            active: data.checked,
            accountId: this.props.match.params.accountId
        }
        dispatch.organizationUnit.setActiveWorkspace(payload);
    }

    async redirectToWorkspace(data) {
        await dispatch.app.setSelectedWorkspaceState(data)
        //await dispatch.app.setSelectedOrganisationData(data)
        const history = this.props.history;
        if(data.active) {
            if(this.props.selectedOrganisation.role === "Member") {
                history.push({
                    pathname: `/app/${this.props.match.params.accountId}/_ws/${data._id}/_at/myactivities`
                });
            }
            else {
                history.push({
                    pathname: `/app/${this.props.match.params.accountId}/_ws/${data._id}/_pb`
                });
            }
        }

    }

    goToSubscription() {
        const history = this.props.history;

        history.push({
            pathname: `https://google.com`,
            target: "_blank"
        });
    }

    async handleReactivateAccount(){
        this.setState({loading: true});
        const payload = {
            email: this.props.user.email,
            accountId: this.props.selectedAccount._id,
            accountUserData:{}
        }
        await dispatch.account.reactivateAccountUsingStripe(payload);
        this.onQueryChange()
        this.setState({loading: false});
    }
    // takeTour() {
    //     dispatch.app.setSelectedOrganisationData(this.props.organizations[0])
    //     const history = this.props.history;

    //     history.push({
    //         pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.organizations[0].id}/home`
    //     });
    // }

    openCreateNewWorkspaceModal(open, type, data) {
        this.setState({
            createNewWorkspaceModalFlag: open,
            type: type,
            data: data
        })
    }

    deleteWorkspace(data) {
        let message = <div className="confirmMessage">
            <h3>Delete Workspace</h3>
            <label>{data.name}</label>
            <p>Are you sure to delete this Workspace?</p>
            <span>This will delete all private & unpublished content, playbooks and initiatives in this workspace.</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                let payload = {
                    organizationId: data._id,
                    accountId: this.props.selectedAccount._id,
                    accountUserId: this.props.user._id
                }
                await dispatch.organizationUnit.deleteWorkspace(payload);
                this.onQueryChange()
            }
        });
    }

    gotToUpgradePage = () => {
        const history = this.props.history;

        history.push({
            pathname: `/app/${this.props.selectedAccount._id}/upgrade`
        });
    }

    manageSubscription = async () => {
        const payload = {
              customerId: this.props.selectedAccount.customerId,
              accountId: this.props.selectedAccount._id
            };
            await dispatch.account.subscriptionUpgradeService(payload);
    }

    getPlanInterval = (createdAt, planExpiryDate) => {
        if (!createdAt || !planExpiryDate) return null;

        const start = new Date(createdAt);
        const end = new Date(planExpiryDate);

        const diffInDays = Math.round(
            (end - start) / (1000 * 60 * 60 * 24)
        );

        if (diffInDays >= 27 && diffInDays <= 31) return 'Monthly';
        if (diffInDays >= 360 && diffInDays <= 370) return 'Yearly';

        return 'Custom';
    };

    render() {
        const { selectedAccount, user, InviteUserLoader, orgCreationError, accountSubscriptionDetail, addedAccountUser } = this.props;
        const planDuration = accountSubscriptionDetail && accountSubscriptionDetail.createdAt && accountSubscriptionDetail.planExpiryDate ? this.getPlanInterval(accountSubscriptionDetail.createdAt, accountSubscriptionDetail.planExpiryDate) : 'Monthly';
        // If user has a account then hiding "NEW TO ASPENIFY" box
        let userHasAccount = true;
        let accountsOwner = user && user.accounts.find(account => {
            return account.role === "customerAdmin"
        })
        if (!accountsOwner) {
            userHasAccount = false
        }
        // ---

        let isAccountUser = false;
        let isAccountDeactivated = false
        let account = user && selectedAccount && user.accounts.filter((account, i) => { return account.id === selectedAccount._id })[0];
        if (account.role === "user") {
            isAccountUser = true; // for now user is not allowed to create wokspace
        } 
        if (account.isActive === false) {
            isAccountDeactivated = true;
        }

        let pricingPlansComponent = null;
        if (this.state.plans) {
            let width = 100 / this.state.plans && this.state.plans.length
            pricingPlansComponent =
                <Card.Group itemsPerRow={this.state.plans && this.state.plans.length}>
                    {this.state.plans
                        .filter((item, i) => { return item.name && !item.name.includes("Enterprise") })
                        .map(function (plan, index) {
                            return (
                                <Card key={index} style={{ margin: "10px 0", width: width + "%", borderRadius: "0" }}>
                                    <NumberCard
                                        name={<div>${plan.price}<span className="f_14"> / month</span></div>}
                                        text={plan.displayName} />
                                </Card>
                            )
                        })
                    }
                    {this.state.plans
                        .filter((item, i) => { return item.name && item.name.includes("Enterprise") })
                        .map(function (plan, index) {
                            return (
                                <Card key={index} style={{ margin: "10px 0", width: width + "%", borderRadius: "0" }}>
                                    <NumberCard
                                        name={<div>Contact Us</div>}
                                        text={plan.displayName} />
                                </Card>
                            )
                        })
                    }
                </Card.Group>
        }

        return (
            <Container fluid >
                <Grid >
                    <Grid.Row>
                        <Grid.Column width={isAccountUser ? 16 : 5}>
                            <div className="welcomeCard">
                                <Image src={shieldIcon} />
                                <div className="cardName">
                                    <label>
                                        <EllipsisTooltip name={`Welcome ${user.firstName}`} />
                                    </label>
                                    <span> You are a {isAccountUser ? "user" : "owner"} of this account </span>
                                </div>
                            </div>
                        </Grid.Column>
                        {isAccountUser ? null :
                            <Grid.Column width={11}>
                                <Card.Group itemsPerRow={3}>
                                    <Card style={{ margin: "10px 0", width: "calc(50% - 1em)", }} >
                                        <div style={{ padding: "0 100px 0 0" }} className="display-flex">
                                            <NumberCard
                                                name={<span>{this.props.selectedAccount.planDisplayName}
                                                    <span className="f_10"> ( {planDuration} )</span>
                                                </span>}
                                                text="Current Account Subscription "
                                            />
                                        </div>
                                        {/* <div className="upgradeTabs">
                                            <Button disabled={isAccountDeactivated || process.env.REACT_APP_ASPEN_SELF_URL === "https://stage.aspenify.com"} className="upgradeButtons" onClick={this.gotToUpgradePage}>
                                                <Icon name="arrow alternate circle up" /> Upgrade
                                            </Button>
                                            <Button disabled={process.env.REACT_APP_ASPEN_SELF_URL === "https://stage.aspenify.com"}className="upgradeButtons" onClick={this.manageSubscription}>
                                                <Icon name="box" /> Manage
                                            </Button>
                                        </div> */}
                                    </Card>
                                    <Card style={{ margin: "10px 0", width: "25%", zIndex: "9", borderRadius: 0 }}>
                                        <NumberCard
                                            name={
                                                accountSubscriptionDetail && accountSubscriptionDetail.createWorkspace && accountSubscriptionDetail.createWorkspace.allowedLimit === -1 ? accountSubscriptionDetail.createWorkspace.entityCount :
                                                    <div>
                                                        {accountSubscriptionDetail && accountSubscriptionDetail.createWorkspace ? accountSubscriptionDetail.createWorkspace.entityCount : 0}
                                                        <span className="f_14"> / {accountSubscriptionDetail && accountSubscriptionDetail.createWorkspace ? accountSubscriptionDetail.createWorkspace.allowedLimit : 0}</span>
                                                    </div>
                                            }
                                            text="Workspaces" />
                                    </Card>
                                    <Card style={{ margin: "10px 0", width: "25%", zIndex: "1" }}>
                                        <NumberCard
                                            name={this.state.accountUserData && this.state.accountUserData.usersTotal}
                                            text="Account Users" />
                                        {
                                            !isAccountDeactivated ?
                                                <Icon onClick={this.gotoInviteUser} className='clr-blue' name='add'
                                                    style={{ "cursor": "pointer", "position": "absolute", "right": "10px", "top": "10px" }}>
                                                </Icon>
                                                :
                                                null
                                        }

                                    </Card>

                                </Card.Group>
                            </Grid.Column>
                        }
                    </Grid.Row>

                    {
                        isAccountDeactivated && !isAccountUser?
                            <Grid.Row>
                                <Grid.Column>
                                    <Message icon color='yellow'>
                                        <Icon name='warning sign' />

                                        <Message.Content>
                                            <Message.Header style={{ marginBottom: '6px', color: '#4a4a4a' }}>
                                             Your account is inactive. Reactivate it to continue.
                                            </Message.Header>

                                            <div style={{ marginBottom: '10px', color: '#4a4a4a' }}>
                                            <div>Reactivation will:</div>
                                            <ul style={{ marginTop: '5px', paddingLeft: '18px' }}>
                                                <li>Restore your access immediately</li>
                                                <li>Preserve your workspace and playbooks</li>
                                                <li>Let you start for free and choose your subscription plan</li>
                                                <li>Allow access to new features</li>
                                            </ul>
                                            </div>
                                            <Button
                                            className='ui button primary'
                                            size='tiny'
                                            onClick={this.handleReactivateAccount}
                                            disabled={!accountsOwner}
                                            style={{ marginBottom: '4px' }}
                                            >
                                            Reactivate Account
                                            </Button>

                                            <div style={{ color: '#4a4a4a' }}>
                                            If you think this is incorrect, reach out to our support team at{' '}
                                            <a href="mailto:support@aspenify.com" style={{color: '#003366'}}>support@aspenify.com</a>
                                            </div>
                                        </Message.Content>
                                        </Message>
                                </Grid.Column>
                            </Grid.Row>
                            : null
                    }

                    <Grid.Row className="pad_0">
                    <LoadingComponent active={this.props.worspacesLoading || this.state.loading || this.props.accountSelectorLoader}  message="Fetching Workspaces" />
                        <Grid.Column>
                            {accountsOwner ? <CommonTable
                                tableName="Workspaces"
                                isAccountDeactivated={isAccountDeactivated}
                                totalCountWithoutSearch={this.props.userWorkspacesTotal}
                                tableHeader={this.state.tableHeader}
                                listData={this.props.organizationList && this.props.organizationList.data}
                                searchable={false}
                                limit={this.state._limit}
                                sort={this.state._sort}
                                selection={true}
                                totalCount={this.props.organizationList && this.props.organizationList.total}
                                loading={this.props.worspacesLoading}
                                onQueryChange={this.onQueryChange}
                                addColumn={this.addColumn}
                                handleDropDownItem={this.handleDropDownItem}
                                handleTableComponent={this.handleTableComponent}
                                loader={this.state.loading}
                            /> : <CommonTable
                            tableName="Workspaces"
                            isAccountDeactivated={isAccountDeactivated}
                            totalCountWithoutSearch={this.props.userWorkspacesTotal}
                            tableHeader={this.state.tableHeader}
                            listData={this.props.organizationList && this.props.organizationList.data}
                            searchable={false}
                            limit={this.state._limit}
                            sort={this.state._sort}
                            selection={true}
                            totalCount={this.props.organizationList && this.props.organizationList.total}
                            loading={this.props.worspacesLoading}
                            onQueryChange={this.onQueryChange}
                            addColumn={this.addColumn}
                            handleDropDownItem={this.handleDropDownItem}
                            handleTableComponent={this.handleTableComponent}
                            loader={this.state.loading}
                        />}
                        </Grid.Column>
                    </Grid.Row>

                    {!userHasAccount ?
                        <Grid.Row>
                            <Grid.Column>
                                <InfoCard
                                    image={createAccount}
                                    head="New to Aspenify?"
                                    subHead="A tool for Communication, Collaborating and Managing with those you invite inside. "
                                    button={
                                        <Button 
                                            className="anchLikeButton" 
                                            onClick={() => this.props.history.push(`/newuser/${user.email}`)}
                                        >
                                            Create Your Own Account
                                        </Button>
                                    }
                                    extra={pricingPlansComponent}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        : null}
                    <Grid.Row>
                        <Grid.Column>
                            <InviteUserModal
                                open={this.state.inviteUserModalFlag}
                                setInviteUserModal={this.setInviteUserModal}
                                selectedAccount={selectedAccount}
                                user={user}
                                InviteUserLoader={InviteUserLoader}
                                addedAccountUser={addedAccountUser}
                                invitedIn="account"
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <CreateNewWorkspaceModal
                                open={this.state.createNewWorkspaceModalFlag}
                                type={this.state.type}
                                data={this.state.data}
                                accountId={selectedAccount._id}
                                user={user}
                                orgCreationError={orgCreationError}
                                openCreateNewWorkspaceModal={this.openCreateNewWorkspaceModal}
                                accountSubscriptionDetail={this.props.accountSubscriptionDetail}
                                tableFilterQuery={this.props.tableFilterQuery}
                            />
                            <AccountSelectionModal
                                user={this.props.user}
                                history={this.props.history}
                                allAccounts={this.props.allAccounts}
                                selectedAccount={this.props.selectedAccount}
                                open={this.props.openViewAccountFlag}
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container >
        )
    }
}

export default MainPage;